export default {
  tiles: [
    {
      id: 0,
      smallCopy:
        'Jessica Encarnacion, founder of The Van Duzer Artisan Market continues to grow her small business thanks to the product offerings from Lower East Side People’s Federal Credit Union. Check out how the credit union helped support Jessica’s dream.',
      videoUrl:
        'https://www.youtube-nocookie.com/embed/0SevYuEZy0U?origin=http://nerdwallet.com&rel=0&modestbranding=1&autohide=1&showinfo=0&controls=0',
      videoCover: 'https://i.ytimg.com/vi/0SevYuEZy0U/sddefault.jpg',
    },
    {
      id: 1,
      smallCopy:
        'Although Darrel has since moved from the Bay Area, his local credit union helped him get back on his feet. Hear his story.',
      videoUrl:
        'https://www.youtube-nocookie.com/embed/8hHQjiobG6U?origin=http://nerdwallet.com&rel=0&modestbranding=1&autohide=1&showinfo=0&controls=0',
      videoCover: 'https://i.ytimg.com/vi_webp/8hHQjiobG6U/sddefault.webp',
    },
  ],
};
